import type { ValueOf } from 'type-fest';

export const ICON_SIZE = {
  SM: 'fa-sm',
  LG: 'fa-lg',
  XL: 'fa-2x',
  XXL: 'fa-3x',
} as const;

type SizeConst = keyof typeof ICON_SIZE;
export type IconSize = typeof ICON_SIZE[SizeConst];

export const ICON_ALIGN = {
  Left: 'left',
  Right: 'right',
} as const;

export type IconAlign = ValueOf<typeof ICON_ALIGN>;
